export interface TaskFunctionOption {
  value: string;
  label: string;
}

export interface TaskFunctionGroup {
  value: number;
  label: string;
  children: readonly TaskFunctionOption[];
}

export const taskFunctions: readonly TaskFunctionGroup[] = [
  {
    value: 1,
    label: 'Acceso y atención al ciudadano',
    children: [
      { value: 'orientacionUsuario', label: 'Orientación usuario' },
      { value: 'accesibilidad', label: 'Accesibilidad' },
      { value: 'ayudaTramitacion', label: 'Ayuda en la tramitación' },
    ],
  },
  {
    value: 2,
    label: 'Tramitación administrativa',
    children: [
      { value: 'procesamientoDocumental', label: 'Procesamiento documental' },
      { value: 'valoracionSolicitudes', label: 'Valoración de solicitudes' },
      { value: 'elaboracionPropuestas', label: 'Elaboración de propuestas: resoluciones, informes...' },
      { value: 'automatizacionTareas', label: 'Automatización de otras tareas' },
    ],
  },
  {
    value: 3,
    label: 'Entrega y seguimiento del servicio',
    children: [
      { value: 'controlEjecucion', label: 'Control de la ejecución' },
      { value: 'personalizacionServicios', label: 'Personalización de servicios' },
    ],
  },
  {
    value: 4,
    label: 'Evaluación y mejora',
    children: [
      { value: 'planificacion', label: 'Planificación' },
      { value: 'visualizacionAvanzada', label: 'Visualización avanzada' },
      { value: 'retroalimentacionCiudadana', label: 'Retroalimentación ciudadana' },
      { value: 'fiscalizacion', label: 'Fiscalización' },
    ],
  },
];

const taskFunctionLabels: Record<string, string> = taskFunctions.reduce<Record<string, string>>((labels, group) => {
  group.children.forEach((child) => {
    labels[child.value] = child.label;
  });

  return labels;
}, { otras: 'Otras funciones' });

export function getTaskFunctionLabel(value: string): string {
  return taskFunctionLabels[value] ?? value;
}
